import {UserRepository} from "@api/repositories/UserRepository";
import {RepositoryFabric} from "../../../api/repositories/RepositoryFabric";
import {PROFILE_FIELDS_BASIC, UserProfile} from "@api/models/UserProfile";
import Vue from 'vue';

/**
 * Helper for fetching profiles and caching them.
 * Also contains selected element.
 * Class is used to show profile
 */
export class ProfileListHelper {
    private readonly userRepository: UserRepository;

    selectedProfile: UserProfile | null = null;
    isLoading = false;
    store: any = null;

    constructor(repositories: RepositoryFabric, store: any) {
        this.userRepository = repositories.get(RepositoryFabric.USER);
        this.store = store;
    }

    /**
     * Set selected user, fetch it from api or get it from cache
     * @param userId
     */
    async setSelected(userId: number) {
        this.isLoading = true;
        try {
            const profile: UserProfile | null = await this.userRepository.profile(userId, PROFILE_FIELDS_BASIC);
            const status: Record<number, string>[] | boolean = await this.userRepository.activity([userId], 'first');
            profile?.setFirstEntranceStatus(status[userId] ? true : false);
            Vue.set(this, 'selectedProfile', profile);
        }
        catch (e) {
            this.store.dispatch('reportException', e, {root: true});
        }

        this.isLoading = false;
    }

    deselect() {
        this.selectedProfile = null;
    }
}
